import React from 'react'
import PieChartIcon from '@material-ui/icons/PieChartOutlined'
import { createColumnInstance } from '../../constants'

// Canonical "net additions" composition -- mirrors the DDP example.
const NET_CASHFLOW_TYPES = [
  'Contributions',
  'Distributions',
  'NetDividendsInterestGainsWithdrawn',
  'Merge In',
  'Merge Out',
  'Journal In',
  'Journal Out'
]

const MEASURE = createColumnInstance('activity', { activityTypes: NET_CASHFLOW_TYPES })

export const allocationByNetCashFlow = Object.freeze({
  id: 'allocation-net-cashflow',
  name: 'Allocation by Net Cash Flow',
  description: 'Donut of net additions / distributions across the top grouping.',
  renderIcon: () => <PieChartIcon style={{ fontSize: 16 }} />,
  toolId: 'allocation',
  resolve: ({ config }) => ({
    ok: true,
    payload: {
      scope: 'level',
      depth: 0,
      groupingLabel: config?.groupings?.[0] || null,
      measureColumnInstance: MEASURE,
      chartType: 'donut'
    }
  })
})
